import React, {Component} from 'react'
import {Button, Col, Container, Form, Row, Spinner} from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'
import axiosInstance from '../../api/utils/axiosInstance'
import FileSaver from 'file-saver'
import './ZahtjevStatus.css'
import {Check, Clock, FileEarmarkText, SlashCircle, X} from 'react-bootstrap-icons'
import DocumentUpload from '../../components/DocumentUpload/DocumentUpload'
import {SECRET_REGEX_PATTERN} from '../../api/utils/constants'
import {getFileLimits} from "../../components/Utils/UslugaVelicinaBroj";

export default class ZahtjevStatus extends Component {

    state = {
        idZahtjevaForm: null,
        kod: null,
        idZahtjeva: null,
        idZahtjevaSts: null,
        sts: null,
        stsString: null,
        isDoc: null,
        komentar: null,
        validated: false,
        isLoading: false,
        showCaptcha: 0,
        arhivirano: 0,
        errorMsg: null,
        captchaFunction: null,
        selectedFiles: [],
        velicinaDatoteka: 0,
        brojDatoteka: 0,
        rgfiVelicinaDatoteka: 0,
        rgfiBrojDatoteka: 0,
        epassVelicinaDatoteka: 0,
        ppBrojDatoteka: 0,
        neprofitniVelicinaDatoteka: 0,
        neprofitniBrojDatoteka: 0,
        proracuniVelicinaDatoteka: 0,
        proracuniBrojDatoteka: 0,
        ponipVelicinaDatoteka: 0,
        steVelicinaDatoteka: 0,
        steBrojDatoteka: 0,
        certVelicinaDatoteka: 0,
        certBrojDatoteka: 0,
        ponip4BrojDatoteka: 0,
        showAlert: null,
        alertMsg: null,
        showAdditionalField: 3,
        requiredField: true,
        zahtjevStsList: [],
        docNum: 1,
        showTimeline: 0,
        usluga: null
    }

    constructor(props) {
        super(props);

        this.recaptchaRef = React.createRef();
    }

    componentDidMount() {
        this.getParamsObrade();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({idZahtjeva: null});
        this.setState({idZahtjevaSts: null});
        this.setState({sts: null});
        this.setState({stsString: null});
        this.setState({isDoc: null});
        this.setState({komentar: null});
        this.setState({validated: false});
        this.setState({isLoading: false});
        this.setState({errorMsg: null});
        this.setState({captchaFunction: null});
        this.setState({selectedFiles: []});
        this.setState({showAlert: false});
        this.setState({alertMsg: false});
        this.setState({showAdditionalField: 3});
        this.setState({requiredField: true});
        this.setState({usluga: null});
    }

    getParamsObrade = () => {
        axiosInstance.get("/parametri").then(res => {
            const showCaptcha = res.data.showCaptcha;
            const appVersion = res.data.verzija;
            const brojDatoteka = res.data.brojDatotekaOdgovor;
            const velicinaDatoteka = res.data.velicinaDatotekaOdgovor;
            const rgfiVelicinaDatoteka = res.data.rgfiVelicinaDatoteka;
            const rgfiBrojDatoteka = res.data.rgfiBrojDatoteka;
            const epassVelicinaDatoteka = res.data.epassVelicinaDatoteka;
            const ppBrojDatoteka = res.data.ppBrojDatoteka;
            const neprofitniVelicinaDatoteka = res.data.neprofitniVelicinaDatoteka;
            const neprofitniBrojDatoteka = res.data.neprofitniBrojDatoteka;
            const proracuniVelicinaDatoteka = res.data.proracuniVelicinaDatoteka;
            const proracuniBrojDatoteka = res.data.proracuniBrojDatoteka;
            const ponipVelicinaDatoteka = res.data.ponipVelicinaDatoteka;
            const ponip4BrojDatoteka = res.data.ponip4BrojDatoteka;
            const steVelicinaDatoteka = res.data.steVelicinaDatoteka;
            const steBrojDatoteka = res.data.steBrojDatoteka;
            const certVelicinaDatoteka = res.data.certVelicinaDatoteka;
            const certBrojDatoteka = res.data.certBrojDatoteka;

            this.setState({
                showCaptcha,
                appVersion,
                brojDatoteka,
                velicinaDatoteka,
                rgfiVelicinaDatoteka,
                rgfiBrojDatoteka,
                epassVelicinaDatoteka,
                ppBrojDatoteka,
                neprofitniVelicinaDatoteka,
                neprofitniBrojDatoteka,
                proracuniBrojDatoteka,
                proracuniVelicinaDatoteka,
                ponipVelicinaDatoteka,
                ponip4BrojDatoteka,
                steVelicinaDatoteka,
                steBrojDatoteka,
                certVelicinaDatoteka,
                certBrojDatoteka
            });
        }).catch(error => {
            this.setState({errorMsg: "Pogreška prilikom učitavanja stranice."});
        });
    }

    handleChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        this.setState({
            [name]: value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            this.setState({validated: true});
        } else {
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.execute();
                this.setState({captchaFunction: () => this.handleStatusCheck()});
            } else {
                this.handleStatusCheck();
            }
            this.setState({isLoading: true});
        }
    }

    handleStatusCheck = () => {
        const provjeraStatusa = {
            idZahtjeva: this.state.idZahtjevaForm,
            kod: this.state.kod,
            captchaResponse: (this.state.showCaptcha === 1 ? this.recaptchaRef.current.getValue() : null)
        }
        axiosInstance.post("/provjeraStatusa", provjeraStatusa).then(res => {
            this.setState({
                idZahtjeva: res.data.idZahtjeva,
                idZahtjevaSts: res.data.idZahtjevaSts,
                sts: res.data.sts,
                stsString: res.data.stsString,
                isDoc: res.data.isDoc,
                komentar: res.data.komentar,
                arhivirano: res.data.arhivirano,
                errorMsg: null,
                isLoading: false,
                validated: false,
                docNum: res.data.docNum,
                zahtjevStsList: res.data.zahtjevStsList,
                showTimeline: res.data.showTimeline,
                usluga: res.data.idUsluge
            });
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.reset();
            }
        }).catch(error => {
            this.setState({
                errorMsg: error.response.data.error.message,
                isLoading: false,
                validated: false,
                sts: null
            });
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.reset();
            }
        });
    }

    handleDownloadPdf = (e, idZahtjevaSts, cnt) => {
        e.preventDefault();
        if (this.state.showCaptcha === 1) {
            this.recaptchaRef.current.execute();
            this.setState({captchaFunction: () => this.downloadPdf(idZahtjevaSts, cnt)});
        } else {
            this.downloadPdf(idZahtjevaSts, cnt);
        }
    }

    downloadPdf = (idZahtjevaSts, cnt) => {
        const provjeraStatusa = {
            idZahtjeva: this.state.idZahtjevaForm,
            kod: this.state.kod,
            captchaResponse: (this.state.showCaptcha === 1 ? this.recaptchaRef.current.getValue() : null),
            isDoc: cnt
        }
        axiosInstance.post("/provjeraStatusa/" + idZahtjevaSts, provjeraStatusa).then(res => {
            this.savePdfFromData(res.data);
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.reset();
            }
        }).catch(error => {
            this.setState({showModal: true, errorMsg: "Nije moguće izvršiti traženu akciju."});
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.reset();
            }
        })
    }

    handleDownloadDocPdf = (e, idZahtjeva, docNum) => {
        e.preventDefault();
        if (this.state.showCaptcha === 1) {
            this.recaptchaRef.current.execute();
            this.setState({captchaFunction: () => this.downloadDocPdf(idZahtjeva, docNum)});
        } else {
            this.downloadDocPdf(idZahtjeva, docNum);
        }
    }

    downloadDocPdf = (idZahtjeva, docNum) => {
        const provjeraStatusa = {
            idZahtjeva: this.state.idZahtjevaForm,
            kod: this.state.kod,
            captchaResponse: (this.state.showCaptcha === 1 ? this.recaptchaRef.current.getValue() : null)
        }
        axiosInstance.post("/provjeraStatusa/" + idZahtjeva + "/" + docNum, provjeraStatusa).then(res => {
            this.savePdfFromData(res.data);
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.reset();
            }
        }).catch(error => {
            this.setState({showModal: true, errorMsg: "Nije moguće izvršiti traženu akciju."});
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.reset();
            }
        })
    }
    savePdfFromData = (data) => {
        var binaryString = window.atob(data.pdf);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        var newBlob = new Blob([bytes], {type: "application/pdf"});

        FileSaver.saveAs(newBlob, data.fileName);
    }

    handleCaptchaChange = () => {
        //this.handleStatusCheck();
        this.state.captchaFunction();
    }

    handleFile = (e) => {
        e.preventDefault();
        this.setState({showAlert: false});
        const { velicinaDatoteka, brojDatoteka } = getFileLimits(this.state);

        var flag = true;
        for (var j = 0; j < e.target.files.length; j++) {
            if (e.target.files[j].type !== 'application/pdf') {
                flag = false;
            }
        }
        var listOfFiles = [];
        this.state.selectedFiles.map((file) =>
            listOfFiles.push(file));

        if (!flag) {
            this.setState({showAlert: true});
            this.setState({alertMsg: "Moguće je predati samo dokument u PDF formatu."});
        } else if ((listOfFiles.length + e.target.files.length) > brojDatoteka) {
            this.setState({showAlert: true});
            const msg = (<span>Nije moguće odabrati više od {brojDatoteka} dokumenata za predaju.</span>)
            this.setState({alertMsg: msg});
            e.stopPropagation();
        } else {
            var sizeOfFiles = 0;
            for (var k = 0; k < listOfFiles.length; k++) {
                sizeOfFiles = sizeOfFiles + listOfFiles[k].size;
            }
            for (var i = 0; i < e.target.files.length; i++) {
                listOfFiles.push(e.target.files[i]);
                sizeOfFiles = sizeOfFiles + e.target.files[i].size;
            }
            if (((sizeOfFiles / 1024) / 1024) > velicinaDatoteka) {
                this.setState({showAlert: true});
                const msg2 = (
                    <span>Nije moguće odabrati dokument jer time prelazite ograničenje od {velicinaDatoteka}MB za predaju dokumentacije.</span>)
                this.setState({alertMsg: msg2});
            } else {
                this.setState({selectedFiles: listOfFiles}, () => {
                    this.checkIfGroupValid();
                });

            }

        }

    }

    checkIfGroupValid = () => {
        if ((document.getElementById("dodatniUnos") != null && document.getElementById("dodatniUnos").value !== null && document.getElementById("dodatniUnos").value !== "")
            || (this.state.selectedFiles.length !== 0)) {
            this.setState({requiredField: false})
        } else {
            this.setState({requiredField: true})
        }
    }

    handleDelete = (e, index) => {
        e.preventDefault();
        this.setState({showAlert: false});
        this.setState({
            selectedFiles: this.state.selectedFiles.filter((_, i) => i !== index)
        }, () => {
            this.checkIfGroupValid();
        });
    }

    handleSubmitFiles = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            this.setState({validated: true});
        } else {
            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.execute();
                this.setState({captchaFunction: () => this.filesToString(this.state.selectedFiles)});
            } else {
                this.filesToString(this.state.selectedFiles);
            }
            this.setState({isLoading: true});
        }
    }

    filesToString = (files) => {
        var dokumenti = [];
        for (var i = 0; i < files.length; i++) {
            const fileReader = new FileReader();
            const file = files[i];
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                const base64 = fileReader.result;
                const str = base64.substr(base64.indexOf(",") + 1);
                const dokument = {
                    data: str,
                    naziv: file.name
                }
                dokumenti.push(dokument);
                if (dokumenti.length === this.state.selectedFiles.length) {
                    this.submitRequest(dokumenti);
                }
            }
        }
    }

    submitRequest = (dokumenti) => {
        const captchaResponse = (this.state.showCaptcha === 1 ? this.recaptchaRef.current.getValue() : null);
        const instance = this;
        const idZahtjeva = this.state.idZahtjevaForm;
        const zahtjev = {
            idZahtjeva: idZahtjeva,
            dokumenti: dokumenti,
            captchaResponse: captchaResponse
        }
        axiosInstance.post("/predajaOdgovora", zahtjev).then(res => {
            // this.setState({ idZahtjevaForm: null });
            this.setState({idZahtjeva: null});
            this.setState({idZahtjevaSts: null});
            this.setState({sts: res.data.sts});
            this.setState({stsString: null});
            this.setState({isDoc: null});
            this.setState({komentar: null});
            this.setState({validated: false});
            this.setState({isLoading: false});
            this.setState({errorMsg: null});
            this.setState({selectedFiles: []});
            this.setState({showAlert: false});
            this.setState({alertMsg: false});
            this.setState({showAdditionalField: 3});
            this.setState({requiredField: true});
            this.setState({usluga: null});

            if (this.state.showCaptcha === 1) {
                this.recaptchaRef.current.reset();
            }

        }).catch(error => {
            var errorMsg = null;
            if (error.response != null) {
                if (error.response.data.error.status !== null) {
                    errorMsg = error.response.data.error.message + " (" + error.response.data.error.status + ")";
                } else {
                    errorMsg = error.response.data.error.message;
                }
            }
            instance.setState({showModal: true, errorMsg: errorMsg});
            this.setState({
                isLoading: false,
                validated: false,
                sts: null
            });
        });

    }

    getStatusColor(sts) {
        switch (sts) {
            case 1:
            case 9:
            case 11:
            case 13:
                return "timeline-badge fina"
            case 2:
            case 3:
            case 6:
            case 7:
            case 12:
                return "timeline-badge"
            case 5:
            case 8:
            case 10:
            case 16:
                return "timeline-badge warning"
            case 14:
                return "timeline-badge"
            default:
                return "timeline-badge success"
        }
    }

    getStatusIcon(sts) {
        switch (sts) {
            case 1:
            case 9:
            case 11:
            case 13:
                return <FileEarmarkText/>
            case 2:
            case 3:
            case 6:
            case 7:
            case 12:
                return <Clock/>
            case 5:
            case 8:
            case 10:
            case 16:
                return <X/>
            case 14:
                return <SlashCircle/>
            default:
                return <Check/>
        }
    }

    render() {
        return (
            <><Container>
                <section aria-label="Forma za provjeru statusa" className='provjera-statusa'>
                    <Row className="justify-content-md-center">
                        <Col lg="6" md="10">
                            <Form noValidate validated={this.state.validated} onSubmit={e => this.handleSubmit(e)}>
                                <Form.Group controlId="idZahtjeva">
                                    <Form.Label>Broj predanog zahtjeva:</Form.Label>
                                    <Form.Control required placeholder="Unesite broj predanog zahtjeva"
                                                  name="idZahtjevaForm" maxLength="9"
                                                  onChange={e => this.handleChange(e)} pattern="\d+"/>
                                    <Form.Control.Feedback type="invalid" role="alert">Obavezan je unos ispravnog broja
                                        predanog zahtjeva.</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="kod">
                                    <Form.Label>Tajni kod:</Form.Label>
                                    <Form.Control required type="password" placeholder="Unesite tajni kod" name="kod"
                                                  maxLength="30" onChange={e => this.handleChange(e)}
                                                  pattern={SECRET_REGEX_PATTERN}/>
                                    <Form.Control.Feedback type="invalid" role="alert">Obavezan je unos ispravnog tajnog
                                        broja.</Form.Control.Feedback>
                                </Form.Group>
                                <div className="d-flex">
                                    <Button className='btn-zahtjev' disabled={this.isLoading}
                                            type="submit">{this.isLoading ?
                                        <Spinner animation="border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </Spinner> : ''}Provjeri status </Button>

                                </div>
                            </Form>
                            {this.state.sts === 13 && this.state.idZahtjeva === null &&
                                <h4 style={{"textAlign": "center", fontWeight: "600", marginTop: "24px"}}>Vaš zahtjev je
                                    uspješno predan.</h4>}
                        </Col>
                    </Row>
                </section>
                {this.state.showCaptcha === 1 ?
                    <ReCAPTCHA
                        aria-hidden="true"
                        ref={this.recaptchaRef}
                        sitekey="6LeW6OMUAAAAAH7Ck0ZLGjaA7Gh6obSk7c4CSDkn"
                        size="invisible"
                        onChange={this.handleCaptchaChange}
                    /> : null
                }

                <section aria-label="Status predanog zahtjeva" className='status-zahtjeva'>
                    <Row className="justify-content-md-center">
                        <Col lg="12" md="12">
                            {this.state.errorMsg ?
                                <h5 style={{"textAlign": "center"}}>{this.state.errorMsg}</h5> :
                                <div>
                                    {this.state.idZahtjeva &&
                                        <React.Fragment>
                                            {this.state.showTimeline === 0 ?
                                                <Row className="justify-content-md-center">
                                                    <Col lg="8" md="10">
                                                        <h5>Zahtjev <b>{this.state.idZahtjeva}</b>
                                                            <b>{this.state.stsString}</b>.</h5>
                                                        {
                                                            this.state.isDoc !== 0 && this.state.sts !== 13 &&
                                                            <div className='text-group'>
                                                                <h5 style={{marginBottom: "16px"}}>Uz predani zahtjev
                                                                    priloženi su Vam dokumenti od strane FINE. </h5>

                                                                {this.state.zahtjevStsList != null && this.state.zahtjevStsList.length > 0
                                                                && this.state.zahtjevStsList.slice(-1)[0].stsDocList != null && this.state.zahtjevStsList.slice(-1)[0].stsDocList.length > 0 ?

                                                                    <div>
                                                                        <h5 style={{marginBottom: "0"}}>Preuzmite
                                                                            priložene dokumente</h5>
                                                                        <h6>(dokumenti su dostupni za preuzimanje 60
                                                                            dana od obrade predanog zahtjeva)</h6>
                                                                        {this.state.zahtjevStsList.slice(-1)[0].stsDocList.map((stsDoc, index) =>
                                                                            <div><span tabIndex="0"
                                                                                       className="zahtjev-tos"
                                                                                       onKeyPress={e => {
                                                                                           if (e.key === 'Enter') {
                                                                                               this.handleDownloadPdf(e, this.state.idZahtjevaSts, stsDoc.isDoc)
                                                                                           }
                                                                                       }}
                                                                                       onClick={(e) => this.handleDownloadPdf(e, this.state.idZahtjevaSts, stsDoc.isDoc)}>{index + 1}. dokument </span><br/>
                                                                            </div>
                                                                        )}
                                                                    </div> :
                                                                    <div>
                                                                        <h5 style={{marginBottom: "0"}}>Preuzmite
                                                                            priložene dokumente</h5>
                                                                        <span tabIndex="0" className="zahtjev-tos"
                                                                              onKeyPress={e => {
                                                                                  if (e.key === 'Enter') {
                                                                                      this.handleDownloadPdf(e, this.state.idZahtjevaSts, this.state.isDoc)
                                                                                  }
                                                                              }}
                                                                              onClick={(e) => this.handleDownloadPdf(e, this.state.idZahtjevaSts, this.state.isDoc)}>1. dokument</span>
                                                                    </div>
                                                                }

                                                            </div>
                                                        }
                                                        {
                                                            this.state.arhivirano !== 0 && this.state.sts !== 13 &&
                                                            <div className='text-group'>
                                                                <h5>Dokument nije dostupan za preuzimanje. Za više
                                                                    informacija kontaktirajte korisničku podršku na broj
                                                                    telefona <a href="tel:08000080">0800 0080</a> ili
                                                                    e-mail adresu <a
                                                                        href="mailto:info@fina.hr">info@fina.hr</a>.
                                                                </h5>
                                                            </div>
                                                        }
                                                        {
                                                            this.state.komentar && this.state.sts !== 13 &&
                                                            <div className='text-group'>
                                                                <h5>Komentar uz status predanog zahtjeva:</h5>
                                                                <h6 className="komentar text-justify">
                                                                    <i>{this.state.komentar}</i></h6>
                                                            </div>
                                                        }
                                                    </Col>
                                                </Row> : null
                                            }

                                            <Row className="justify-content-md-center text-group">
                                                <Col lg="8" md="10">
                                                    {this.state.sts === 12 &&
                                                        <Form noValidate validated={this.state.validated}
                                                              onSubmit={e => this.handleSubmitFiles(e)}>
                                                            <DocumentUpload selectedFiles={this.state.selectedFiles}
                                                                            showAlert={this.state.showAlert}
                                                                            alertMsg={this.state.alertMsg}
                                                                            handleFile={this.handleFile}
                                                                            handleDelete={this.handleDelete}
                                                                            requiredField={this.state.requiredField}
                                                                            showAdditionalField={this.state.showAdditionalField}/>
                                                            <div className="d-flex">
                                                                <Button className='btn-zahtjev'
                                                                        disabled={this.state.isLoading}
                                                                        type="submit">{this.state.isLoading ?
                                                                    <Spinner animation="border" role="status">
                                                                        <span className="sr-only">Loading...</span>
                                                                    </Spinner> : ''}Predaj odgovor</Button>
                                                            </div>
                                                        </Form>
                                                    }
                                                </Col>
                                            </Row>

                                            {this.state.showTimeline === 1 && this.state.zahtjevStsList.length > 0 ?
                                                <Row className="justify-content-md-center">
                                                    <Col lg="10" md="10">
                                                        {this.state.arhivirano !== 0 &&
                                                            <Row className="justify-content-center text-group">
                                                                <Col xs={10} md={6}>
                                                                    <h6 style={{"textAlign": "center"}}>Dokumenti nisu
                                                                        dostupni za preuzimanje. Za više informacija
                                                                        kontaktirajte korisničku podršku na broj
                                                                        telefona <a href="tel:08000080">0800
                                                                            0080</a> ili e-mail adresu <a
                                                                            href="mailto:info@fina.hr">info@fina.hr</a>
                                                                    </h6>
                                                                </Col>
                                                            </Row>
                                                        }
                                                        <ul className="timeline">
                                                            {this.state.zahtjevStsList.slice(0).reverse().map((status, key) => {
                                                                    return status.stsId === 12 ?
                                                                        <li key={key} className="timeline-inverted">
                                                                            <div
                                                                                className={this.getStatusColor(status.stsId)}>{this.getStatusIcon(status.stsId)}</div>
                                                                            <div className="timeline-panel">
                                                                                <div className="timeline-heading">
                                                                                    <h5 className="timeline-title">
                                                                                        <b>Zahtjev {this.state.idZahtjeva} {status.sts}</b>
                                                                                    </h5>
                                                                                </div>
                                                                                {status.komentar !== null && status.komentar.trim() !== "" ?
                                                                                    <div className="timeline-body komentar">
                                                                                        <p><b>Komentar uz status predanog
                                                                                            zahtjeva:</b></p>
                                                                                        <p style={{"wordBreak": "break-word"}}>
                                                                                            <i>{status.komentar}</i></p>
                                                                                    </div> : null
                                                                                }

                                                                                {status.docLoc !== null && this.state.arhivirano === 0 ?
                                                                                    <div className="timeline-body docs">
                                                                                        <p><b>Preuzmite priložene
                                                                                            dokumente:</b></p>
                                                                                        <Row>
                                                                                            {status.stsDocList.map((stsDoc, cnt) => {
                                                                                                return <Col key={cnt}
                                                                                                            lg={4}><span
                                                                                                    tabIndex="0"
                                                                                                    className="zahtjev-tos"
                                                                                                    onKeyPress={e => {
                                                                                                        if (e.key === 'Enter') {
                                                                                                            this.handleDownloadPdf(e, status.idZahtjevSts, stsDoc.isDoc)
                                                                                                        }
                                                                                                    }}
                                                                                                    onClick={(e) => this.handleDownloadPdf(e, status.idZahtjevSts, stsDoc.isDoc)}>{cnt + 1}. Dokument</span></Col>

                                                                                            })}
                                                                                        </Row>
                                                                                    </div> : null
                                                                                }

                                                                            </div>
                                                                        </li>
                                                                        :
                                                                        <li key={key}>
                                                                            <div
                                                                                className={this.getStatusColor(status.stsId)}>{this.getStatusIcon(status.stsId)}</div>
                                                                            <div className="timeline-panel">
                                                                                <div className="timeline-heading">
                                                                                    <h5 className="timeline-title">
                                                                                        <b>Zahtjev {this.state.idZahtjeva} {status.sts}</b>
                                                                                    </h5>
                                                                                </div>
                                                                                {status.komentar !== null && status.komentar.trim() !== "" ?
                                                                                    <div className="timeline-body">
                                                                                        <p><b>Komentar uz status predanog
                                                                                            zahtjeva:</b></p>
                                                                                        <p style={{"wordBreak": "break-word"}}>
                                                                                            <i>{status.komentar}</i></p>
                                                                                    </div> : null
                                                                                }
                                                                                {status.docLoc !== null && this.state.arhivirano === 0 ?
                                                                                    <div className="timeline-body docs">
                                                                                        <p><b>Preuzmite priložene
                                                                                            dokumente:</b></p>
                                                                                        <Row>
                                                                                            {status.stsDocList.map((stsDoc, cnt) => {
                                                                                                return <Col key={cnt}
                                                                                                            lg={4}><span
                                                                                                    tabIndex="0"
                                                                                                    style={{color: "#004fa8"}}
                                                                                                    className="zahtjev-tos"
                                                                                                    onKeyPress={e => {
                                                                                                        if (e.key === 'Enter') {
                                                                                                            this.handleDownloadPdf(e, status.idZahtjevSts, stsDoc.isDoc)
                                                                                                        }
                                                                                                    }}
                                                                                                    onClick={(e) => this.handleDownloadPdf(e, status.idZahtjevSts, stsDoc.isDoc)}>{cnt + 1}. Dokument</span></Col>

                                                                                            })}
                                                                                        </Row>
                                                                                    </div> : null
                                                                                }
                                                                            </div>
                                                                        </li>
                                                                }
                                                            )}
                                                        </ul>
                                                        <h6 style={{"textAlign": "center"}}>(dokumenti su dostupni za
                                                            preuzimanje 60 dana od obrade predanog zahtjeva)</h6>
                                                    </Col>
                                                </Row> : null
                                            }
                                        </React.Fragment>
                                    }
                                </div>
                            }
                        </Col>
                    </Row>
                </section>
            </Container>
                <footer className="footer" aria-label="Podnožje">
                    <span className="version">{this.state.appVersion}</span>
                </footer>
            </>
        )
    }
}
